import { render, staticRenderFns } from "./challenge-friends.vue?vue&type=template&id=5a6022da&scoped=true"
import script from "./challenge-friends.vue?vue&type=script&lang=js"
export * from "./challenge-friends.vue?vue&type=script&lang=js"
import style0 from "./challenge-friends.vue?vue&type=style&index=0&id=5a6022da&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6022da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a6022da')) {
      api.createRecord('5a6022da', component.options)
    } else {
      api.reload('5a6022da', component.options)
    }
    module.hot.accept("./challenge-friends.vue?vue&type=template&id=5a6022da&scoped=true", function () {
      api.rerender('5a6022da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/dashboard/challenge-friends/views/challenge-friends.vue"
export default component.exports